import { useForm } from 'react-hook-form'
import { useState, useEffect, useContext, useRef } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import { projectContext, loadingContext, urlValue, unfolder, onImportExcelAsync, openAlert, closeAlert, useTranslate } from '../lib'
import SelectCodeModal from './SelectCodeModal'
import '../styles/styles.css'
import '../styles/answerCRUD.scss'
import Loading from './Loading'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import ChatBot2 from "./ChatBot2";
import BoxInfo from './common/BoxInfo'
import { Alerts } from './common/Alerts'
import Button from './provider/button/button.jsx'
import H2 from './provider/h2/H2.jsx'
import H3 from './provider/h3/H3.jsx'

export function AnswerCRUD({
  sidePanel,
  setSidePanel,
  title,
  edit,
  selectedAnswer,
  setSelectedAnswer,
  isModalOpen,
  setIsModalOpen,
  onAnswerUpdated,
}) {
  const [panel, setPanel] = useState('')
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [loading, setLoading] = useContext(loadingContext)
  const [error, setError] = useState({ name: "" })
  const [audioA, setAudioA] = useState(null)
  const [defaultSentiment, setDefaultSentiment] = useState('')
  const [voiceSelected, setVoiceSelected] = useState(null)
  const [modalCode, setModalCode] = useState({code: false})
  const [alert, setAlert] = useState({title: '', visible: false})
  const contentRef = useRef();
  const [currentOrder, setCurrentOrder] = useState(selectedAnswer.order || 0);
  const { t } = useTranslate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    clearErrors
  } = useForm({
    defaultValues: {
      technical: ' ',
      type: '1',
    },
  })

  useEffect(() => {
    setPanel(sidePanel)
  }, [sidePanel])

  useEffect(() => {
    const orderValue = selectedAnswer.order || 1;

    setValue('order', orderValue < 1 ? 1 : orderValue);
    setValue('code', selectedAnswer.code)
    setValue('name', selectedAnswer.name)
    setValue('content', selectedAnswer.content.text)
    setValue('style', selectedAnswer.style)
    setValue('rate', selectedAnswer?.rate || '1%')
    setValue('pitch', selectedAnswer?.pitch || '1%')
    setValue('volume', selectedAnswer?.volume || '1%')
    setValue('type', `${1}`)

    document.querySelector("#rate_rg").value = selectedAnswer?.rate?.replace("%", "").replace("+", "") || 1;
    document.querySelector("#pitch_rg").value = selectedAnswer?.pitch?.replace("%", "").replace("+", "") || 1;
    document.querySelector("#volume_rg").value = selectedAnswer?.volume?.replace("%", "").replace("+", "") || 1;
    setDefaultSentiment(selectedAnswer?.default_sentiment || '');

    const orderInput = document.getElementById(`order_number_${selectedAnswer.id}`);
    if (orderInput) {
      const orderInputValue = selectedAnswer.order || 1;
      orderInput.value = orderInputValue < 1 ? 1 : orderInputValue;
    }

  }, [selectedAnswer])

  useEffect(() => {
    if (sidePanel === 'detail' && selectedAnswer.id) {
      const orderInput = document.getElementById(`order_number_${selectedAnswer.id}`);
      if (orderInput) {
        orderInput.value = selectedAnswer.order || 0;
      }
    }
  }, [sidePanel, selectedAnswer.id, selectedAnswer.order])

  const handleCancel = () => {
    setSelectedAnswer({ content: {} })
    clearErrors()
    setSidePanel('new')
  }

  const updateAnswerRequest = async (method = 'post', dataSend)=>{
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken;
    let route = '';

    switch(method){
      case 'post': 
        route = '/studio/answer/create';
        break;
      case 'put': 
        route = '/studio/answer/update';
        break;
      default:
        route = '';
    }

    if(route === ''){
      return Error('Method not permitted.');
    }

    return await axios({
      method: 'post',
      url: `${urlValue + route}`,
      headers: {
        user: id,
        'Content-Type': 'application/json',
        'access-token': token,
        projectid: selectedProject.id,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: dataSend,
    });
  }

  const onSubmit = async data => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let ok = true
    const exp = /^[A-Za-zÀ-ÿ0-9-,._'()-¿?\s]+$/g;
    if (!exp.test(data.name)) {
      ok = false;
      setError({ ...error, name: t('errors.nameInvalid') })
    }

    if (ok) {
      setLoading(true)
      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
      let ccms_name = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').ccms_name

      const newOrder = parseInt(data.order) || 1;
      
      const dataSend = {
        id: selectedAnswer.id,
        code: data.code,
        name: data.name,
        type: parseInt(1),
        content: {
          text: data.content,
        },
        gender: data.gender,
        style: data.style,
        rate: data.rate,
        pitch: data.pitch,
        volume: data.volume,
        technical_text: "{}",
        locale: "en-US",
        project: selectedProject.id,
        channel: 1,
        edited_by: id,
        user_id: id,
        ccms_name: ccms_name,
        last_update: '2022-02-24',
        transactional: 0,
        webhook: null,
        default_sentiment: defaultSentiment,
        order: newOrder,
      }
      try {
        if (panel === 'edit' && selectedAnswer.id && newOrder !== (selectedAnswer.order || 0)) {

          await updateAllAnswersOrder(selectedAnswer.id, newOrder, selectedProject.id);
          
          await updateAnswerRequest('put', dataSend);
        }
        else if (panel === 'new' || !selectedAnswer.id) {
          
          const response = await updateAnswerRequest('post', dataSend);
          
          const newAnswerId = response.data.id;
          
          if (newOrder > 0) {
            await updateAllAnswersOrder(newAnswerId, newOrder, selectedProject.id);
          }
          
          dataSend.id = newAnswerId;


        }
        else {
          await updateAnswerRequest('put', dataSend);
        }
        
        openAlert('#alert-ac', () => {setAlert({title: t('alerts.answerSaved'), visible: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
        
        setSelectedAnswer({
          ...selectedAnswer,
          ...dataSend,
          order: newOrder,
          content: {
            text: data.content,
          }
        });
        setSidePanel('detail');
        
        setLoading(false);

        if (typeof onAnswerUpdated === 'function') {
          onAnswerUpdated();
        }
      } catch (error) {
        console.log(error);
        openAlert('#alert-ac', () => {setAlert({title: t('alerts.answerNotSaved'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
        setLoading(false);
      }
    }
  }

  const handleOrderChange = (e) => {
    let newOrder = parseInt(e.target.value) || 0;
    if (newOrder < 1) {
      newOrder = 1;
      e.target.value = 1;
    }
    setCurrentOrder(newOrder);
    setValue('order', newOrder);
  };

  const updateAllAnswersOrder = async (answerID, newOrder, projectID) => {
    try {
      if (!answerID) {
        throw new Error('answerID is required for order update');
      }
  
      if (newOrder < 1) {
        newOrder = 1;
      }
  
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
      
      const response = await axios({
        method: 'get',
        url: `${urlValue}/studio/project/${projectID}/answers`,
        headers: {
          user: id,
          'access-token': token,
        },
      });
      
      const allAnswers = response.data;
      const updatePromises = [];
  
      const orderCounts = {};
      let needsReindexing = false;
      
      for (const answer of allAnswers) {
        if (answer.order !== null && answer.order !== undefined) {
          if (answer.order < 1) {
            needsReindexing = true;
          }
          orderCounts[answer.order] = (orderCounts[answer.order] || 0) + 1;
        }
      }
      
      const duplicateOrders = Object.keys(orderCounts).filter(order => orderCounts[order] > 1);
      if (duplicateOrders.length > 0) {
        needsReindexing = true;
      }
      
      const sortedAnswers = [...allAnswers]
        .filter(a => a.order !== null && a.order !== undefined)
        .sort((a, b) => (a.order || 0) - (b.order || 0));
      
      let currentAnswerIndex = -1;
      for (let i = 0; i < sortedAnswers.length; i++) {
        if (sortedAnswers[i].id === answerID) {
          currentAnswerIndex = i;
          break;
        }
      }
      
      const currentAnswer = currentAnswerIndex !== -1 ? sortedAnswers.splice(currentAnswerIndex, 1)[0] : null;
      
      const insertIndex = Math.min(Math.max(newOrder - 1, 0), sortedAnswers.length);
      
      if (currentAnswer) {
        sortedAnswers.splice(insertIndex, 0, currentAnswer);
      }
      
      for (let i = 0; i < sortedAnswers.length; i++) {
        const answer = sortedAnswers[i];
        const correctOrder = i + 1;
        
        if (answer.id === answerID) {
          updatePromises.push(
            updateAnswerOrderRequest(answer.id, newOrder, projectID)
          );
        } else if (answer.order !== correctOrder) {
          updatePromises.push(
            updateAnswerOrderRequest(answer.id, correctOrder, projectID)
          );
        }
      }
      
      await Promise.all(updatePromises);

      return;
    } catch (error) {
      console.error('Error updating order:', error);
      throw error;
    }
  };

  const [AnswersExcel, setAnswersExcel] = useState([]);
  const [loadingUpload, setLoadingUpload] = useState(false)


  const uploadMaxive = async () => {

    if (!loadingUpload && AnswersExcel.length > 0 && AnswersExcel.length <= 101) {

      setLoadingUpload(true)
      setTimeout(async () => {
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

        let routeSelected = panel === 'edit' ? '/studio/answer/update' : '/studio/answer/create';

        for (var i = 0; i < AnswersExcel.length; i++) {
          const rest = await axios({
            method: 'post',
            url: `${urlValue . routeSelected}`,
            headers: {
              user: id,
              'Content-Type': 'application/json',
              'access-token': token,
              projectid: selectedProject.id,
              'X-CSRF-Token': csrfToken
            },
            withCredentials: true,
            data: {
              id: null,
              code: AnswersExcel[i].Code,
              name: AnswersExcel[i].Name?.trim(),
              type: parseInt(AnswersExcel[i].Type),
              content: {
                text: AnswersExcel[i].Content,
              },
              technical_text: AnswersExcel[i].Technical_Text,
              locale: AnswersExcel[i].Locale,
              project: selectedProject.id,
              channel: 1,
              edited_by: null,
              last_update: '2022-02-24',
              transactional: 0,
              webhook: null,
            },
          })
        }

        window.location.reload();
      }, 1000)

    } else {
      alert(t('alerts.intentExcelLimit'))
    }

  }
  const prepareExcel = async (file) => {
    const DatosExcel = await onImportExcelAsync(file);
    setAnswersExcel(DatosExcel);
    uploadMaxive();
  }

  const convertRangeRate = (e) => {
    setValue('rate', e.target.value + '%');
  }

  const convertRangePitch = (e) => {
    setValue('pitch', e.target.value + '%');
  }

  const convertRangeVolume = (e) => {
    setValue('volume', '+' + e.target.value + '.00%');
  }

  const playAnswer = async () => {
    let tokenN = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    
    let voice = voiceSelected.voice;
    let url = `${process.env.REACT_APP_AZURE_ENDPOINT}/sts/v1.0/issuetoken`
    const resToke = await axios.post(url, {}, {
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY
      }
    })
    let token = resToke.data;
    
    const contentAws = document.querySelector("#contentAws");
    const pitch = document.querySelector("#pitch")?.value;
    const style = document.querySelector("#style")?.value;
    const rate = document.querySelector("#rate")?.value;
    const volume = document.querySelector("#volume")?.value;
    
    if (contentAws?.value !== "") {

      let speaker1 = `<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" 
                          xmlns:mstts="https://www.w3.org/2001/mstts" xml:lang="en-US">
                        <voice name="${voice?.trim()?.replaceAll('_', '-')}">
                            <prosody rate="${rate}" pitch="${pitch}" volume="${volume}">
                                <mstts:express-as style="${style}">
                                    ${contentAws?.value}
                                </mstts:express-as>
                            </prosody>
                        </voice>
                     </speak>`

      try {
        const res3 = await fetch('https://eastus.tts.speech.microsoft.com/cognitiveservices/v1', {
          method: 'POST',
          headers: {
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY,
            Authorization: `Bearer ${token}`,
            'cache-control': 'no-cache',
            'X-Microsoft-OutputFormat': 'riff-24khz-16bit-mono-pcm',
            'Content-Type': 'application/ssml+xml'
          },
          body: speaker1
        });
        if (!res3.ok) {
          throw new Error('Fetch failed!');
        }
        const wavFile = await res3.blob();
        document.querySelector('#audioID').src = URL.createObjectURL(wavFile);
        document.querySelector('#audioID').play();
      } catch (error) {
        console.log(error)
      }


    }

  }

  const changeSentiment = (sentiment, e) => {
    setDefaultSentiment(sentiment)
    
  }

  const getVoiceProject = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    const res = await axios.post(`${urlValue}/studio/answer/voice/selected`,
      { id: selectedProject.voice_id },
      {
        headers: {
          user: id,
          'Content-Type': 'application/json',
          'access-token': token,
          projectid: selectedProject.id,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
      });
    
    if (res.status === 200) {
      setVoiceSelected(res.data)
    }
  }

  const updateAnswerOrderRequest = async (answerID, newOrder, projectID) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    return await axios({
      method: 'post',
      url: `${urlValue}/studio/answer/order`,
      headers: {
        user: id,
        'Content-Type': 'application/json',
        'access-token': token,
        projectid: projectID,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        id: answerID,
        order: newOrder,
        project: projectID
      },
    });
  }

  useEffect(() => {
    getVoiceProject()
  }, [])

  return (
    <>
      <ChatBot2 project={selectedProject} />

      <div className="answerCRUD  ">
        <div className="scroll-internal ">
          {/*<h2 style={{ color: "#0B5FA3" }}>{title}</h2>*/}
          <div className="d-flex flex-row align-items-center justify-content-between">
            <H2 text={title} />
            <div className='d-flex flex-row align-items-center' style={{marginBottom: 20, marginRight: 15}}>
              <span className='m-1' style={{fontSize: 12, textTransform: 'uppercase', color: "#474746"}}>{t('common.order')}:</span>
              <input 
                id={'order_number_'+selectedAnswer.id} 
                type='number' 
                className='input-data ml-2' 
                style={{maxWidth: 70}} 
                {...register('order', { valueAsNumber: true })}
                onChange={handleOrderChange} 
                defaultValue={selectedAnswer.order || 0}
                disabled={!edit}
              />
            </div>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-row flex-wrap">

            <div className="w-full items-center">
              <div className="flex flex-row w-full flex-1 items-center">
                <div className="inputs flex ">
                  <div className="input">
                    <div className="flex">
                      <H3 text="Code:" style={{fontWeight: 'bold'}} />
                      <img id="code-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                      <Tooltip events={['click']} anchorId="code-tp" 
                        html={t('answers.createTooltip')} place="top" />
                    </div>
                    <div
                      onClick={ ()=>{ edit ? setModalCode({ code: true }) : <></> } }
                      className={ edit ?  'pointer' : "" }
                    >
                      <input
                        className='input-data'
                        {...register('code', { required: true })}
                        type="text"
                        disabled={false}
                      />
                    </div>
                  </div>
                </div>
                <div className="inputs flex flex-1 ml-5">
                  <div className="input tooltip">
                  <BoxInfo
                    id="answer-name"
                    titleClass='mr-0-4 f-16 title-intent'
                    title={`${t('common.name')}:`}
                    place="top"
                    containerClass='mr-0-5'
                    render={t('answers.nameTooltip')}
                  />

                    <input
                      id='name-tp'
                      placeholder={t('answers.namePlaceholder')}
                      className='input-data'
                      {...register('name', { required: true })}
                      type="text"
                      disabled={!edit}
                    />
                    <Tooltip anchorId="name-tp" content={t('alerts.charactersNameTooltip')} place="top" />
                    {/* <span className="tooltiptext">Only these characters are accepted A-Za-z0-9-,._'¿? <div className='triangulo'></div></span> */}
                  </div>
                </div>
              </div>

              <div className="flex flex-col w-full flex-1 mt-4">
                <div className="inputs" style={{ width: '100%' }}>
                  <div className="input" id="textarea">
                    <BoxInfo
                      id="answer-content"
                      titleClass='mr-0-4 f-16 title-intent'
                      title={`${t('common.content')}:`}
                      place="top"
                      containerClass='mr-0-5'
                      render={t('answers.contentTooltip')}
                    />
                    <textarea
                      id="contentAws"
                      placeholder={t('answers.contentPlaceholder')}
                      {...register('content', { required: true })}
                      type="text"
                      disabled={!edit}
                      className='input-data'
                      style={{ height: 250 }}
                    />
                    {/* <Tooltip anchorId="contentAws" content={`Enter the answer text the AI will provide`} place="top" /> */}
                  </div>

                </div>
              </div>
            </div>

            

            <div className='d-flex flex-row align-items-center mt-4 w-100' style={{justifyContent: 'space-between'}}>

              <div className="flex flex-row items-center" style={{ paddingRight: 20 }}>
                <div className="inputs" style={{ width: 'auto' }}>
                  <div className="input" >
                    <div className="flex flex-row items-center" style={{minWidth: 100}}>
                      <H3 text="Default to:" style={{fontWeight: 'bold'}} />
                      <img id="default-tp" src={'/icons/tooltip-indicator-icon.svg'} style={{ width: 15, height: 15, cursor: 'pointer', objectFit: 'fill', marginLeft: 7 }} className="cursor-pointer w-[15px] h-[15px] object-fill ml-[7px]" alt="" />
                    </div>

                    <Tooltip events={['click']} anchorId="default-tp" html={t('answers.sentimentTooltip')} place="top" />

                  </div>
                </div>
                <img className={`${defaultSentiment === 'unfriendly' && 'set-sentiment'} opa-icon ml-2`} onClick={(e) => changeSentiment('unfriendly', e)} src='/icons/status-1.png' alt='icon' style={{ objectFit: "contain", width: "29px", cursor: "pointer" }} />
                <img className={`${defaultSentiment === 'sad' && 'set-sentiment'} opa-icon ml-2`} onClick={(e) => changeSentiment('sad', e)} src='/icons/status-2.png' alt='icon' style={{ objectFit: "contain", width: "29px", cursor: "pointer" }} />
                <img className={`${defaultSentiment === 'friendly' && 'set-sentiment'} opa-icon ml-2`} onClick={(e) => changeSentiment('friendly', e)} src='/icons/status-3.png' alt='icon' style={{ objectFit: "contain", width: "29px", cursor: "pointer" }} />
                <img className={`${defaultSentiment === 'cheerful' && 'set-sentiment'} opa-icon ml-2`} onClick={(e) => changeSentiment('cheerful', e)} src='/icons/status-4.png' alt='icon' style={{ objectFit: "contain", width: "29px", cursor: "pointer" }} />
                <img className={`${defaultSentiment === 'excited' && 'set-sentiment'} opa-icon ml-2`} onClick={(e) => changeSentiment('excited', e)} src='/icons/status-5.png' alt='icon' style={{ objectFit: "contain", width: "29px", cursor: "pointer" }} />
              </div>
{/*
              <div className="d-flex flex-row align-items-center">
                <BoxInfo
                  id="gender-tp"
                  titleClass='mr-0-3 color-label f-16 title-intent'
                  title="Gender:"
                  place="top"
                  containerClass='mr-0-1'
                  render={`<div> This option allows you to display specific avatars </br> based on the gender of the bot's voice and chat. </div>`}
                />
                <div className="select ml-3">
                  <select id="gender" className="w-100 select-nesting input-data" {...register('gender', { required: false })}
                    style={{ minWidth: 100, padding: 8 }}>
                    <option value="male">{t('common.male')}</option>
                    <option value="female">{t('common.female')}</option>
                  </select>
                </div>
              </div>
*/}
            </div>

            <div className="w-100   d-flex flex-wrap mt-3 pt-3 pb-3" style={{ paddingRight: 22, width: '100% !important', borderTop: '1px solid #707070', }}>

              <div className='flex flex-row items-center '>
              <BoxInfo
                  id="answer-modulation"
                  titleClass='mr-0-4 f-16 title-intent'
                  title={t('answers.modulation')}
                  place="top"
                  containerClass='mr-0-5'
                  render={t('answers.modulationTooltip')}
                />
                <button className="btn-nesting ml-5 mr-3" type="button" onClick={() => { playAnswer() }}> {t('common.play')} </button>
                <audio id="audioID" controls >
                  <source type="audio/mpeg" />
                </audio>
              </div>
              <div className="input w-100 d-flex flex-row flex-wrap justify-space-between">
                <div className="d-flex flex-row align-items-center mt-2" style={{ width: '40%', minWidth: 250 }}>
                  <BoxInfo
                    id="style-tp"
                    titleClass='mr-0-3 color-label f-16  title-intent'
                    title={t('answers.style')}
                    place="top"
                    containerClass='mr-0-1'
                    render={t('answers.styleTooltip')}
                  />
                  <div className="select ml-3">
                    <select id="style" className="w-100   select-nesting input-data" {...register('style', { required: false })}
                      style={{ minWidth: 220, padding: 8 }}>
                      <option disabled selected>{t('common.select')}</option>
                      <option value="angry">{t('answers.angry')}</option>
                      <option value="cheerful">{t('answers.cheerful')}</option>
                      <option value="excited">{t('answers.excited')}</option>
                      <option value="fearful">{t('answers.fearful')}</option>
                      <option value="friendly">{t('answers.friendly')}</option>
                      <option value="hopeful">{t('answers.hopeful')}</option>
                      <option value="unfriendly">{t('answers.unfriendly')}</option>
                      <option value="sad">{t('answers.sad')}</option>
                      <option value="terrified">{t('answers.terrified')}</option>
                    </select>
                  </div>
                </div>

                <div className="d-flex flex-row align-items-center mt-2" style={{ width: '40%', minWidth: 250 }}>
                  <BoxInfo
                    id="rate-tp" titleStyle={{fontWeight: 400, fontSize: 12}}
                    titleClass='mr-0-3'
                    title={`${t('menu.rate')}:`}
                    place="top"
                    containerClass='mr-0-1'
                    render={t('answers.rateTooltip')}
                  />
                  <div className="d-flex flex-row pl-2" style={{ maxWidth: 100 }}>
                    <input type="range" onChange={convertRangeRate} id="rate_rg" className="ml-2" />
                    <input type="text"  {...register('rate', { required: false })} id="rate" className="ml-3 input-data"
                      style={{ maxWidth: 80, paddingLeft: 10 }} />
                  </div>
                </div>

                <div className="d-flex flex-row align-items-center mt-2" style={{ width: '40%', minWidth: 250 }}>
                  <BoxInfo
                    id="pitch-tp" titleStyle={{fontWeight: 400, fontSize: 12}}
                    titleClass='mr-0-3'
                    title={t('answers.pitch')}
                    place="top"
                    containerClass='mr-0-1'
                    render={t('answers.pitchTooltip')}
                  />
                  <div className="d-flex flex-row pl-2" style={{ maxWidth: 100 }}>
                    <input type="range" id="pitch_rg" onChange={convertRangePitch} className="ml-2" />
                    <input type="text" {...register('pitch', { required: false })} id="pitch" className="ml-3 input-data"
                      style={{ maxWidth: 80, paddingLeft: 10 }} />
                  </div>
                </div>

                <div className="d-flex flex-row align-items-center mt-2" style={{ width: '40%', minWidth: 250 }}>
                  <BoxInfo
                    id="volume-tp" titleStyle={{fontWeight: 400, fontSize: 12}}
                    titleClass='mr-0-3'
                    title={t('answers.volume')}
                    place="top"
                    containerClass='mr-0-1'
                    render={t('answers.volumeTooltip')}
                  />
                  <div className="d-flex flex-row pl-2" style={{ maxWidth: 100 }}>
                    <input type="range" id="volume_rg" onChange={convertRangeVolume} className="ml-2" style={{ maxWidth: 110 }} />
                    <input type="text" {...register('volume', { required: false })} id="volume" className="ml-3 input-data"
                      style={{ maxWidth: 80, paddingLeft: 10 }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="footer">
              <div className='cont-buttons'>
                {edit &&
                  (errors.code ||
                    errors.name ||
                    errors.locale ||
                    errors.content ||
                    errors.technical) ? (
                  <span className='errors-msg'>{t('menu.fieldsRequired')}</span>
                ) : (
                  <span> </span>
                )}
                <span className='errors-msg'  >{error.name}</span>
              </div>
              <div className="buttons">
                <Button 
                  type="button"
                  label={t('common.cancel')}
                  onClick={handleCancel}
                  className='create btn-bottom btn-bottom-cancel'
                />

                <Button 
                  type="submit"
                  label={edit ? t('common.save') : t('common.create')}
                  className='create btn-bottom btn-bottom-create'
                />

                {/*
                <button className="create btn-bottom btn-bottom-cancel" type="submit" style={{ backgroundColor: "#002565" }}>
                <button className="create btn-bottom btn-bottom-cancel" type="button" onClick={(handleCancel)} style={{ backgroundColor: "#002565" }}>
                  Cancel
                </button>
                
                <button className="create btn-bottom btn-bottom-create" type="submit">
                  {edit?'Save': 'Create'}
                </button>
                */}

                {/* {panel == 'edit' ? (
                <> */}
                {/* <button
                    className="cancel"
                    type="button"
                    onClick={() => setSidePanel('detail')}
                  >
                    Cancel
                  </button>
                  <button className="create" type="submit">
                    {t('common.confirm')}
                  </button> */}
                {/* </>
              ) : panel == 'new' ? (
                <> */}
                {/* <button
                    className="cancel"
                    type="button"
                    onClick={() => setSidePanel('detail')}
                  >
                    Cancel
                  </button> */}
                {/* <button className="create" type="submit">
                    Save
                  </button> */}
                {/* </>
              ) : (
                selectedAnswer.id && ( */}
                {/* <button
                    className="create"
                    type="button"
                    onClick={() => setSidePanel('edit')}
                  >
                    Edit
                  </button> */}
                {/* )
              )} */}
              </div>
            </div>
          </form>
        </div>
       
      {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
      </div>
     {modalCode.code&& <SelectCodeModal
        isModalOpen={modalCode}
        setIsModalOpen={setModalCode}
        setValue={setValue}
      />}

    </>
  )
}
